"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabelaCorpo = TabelaCorpo;
var react_1 = __importStar(require("react"));
var TabelaCorpoCelula_1 = require("../TabelaCorpoCelula/TabelaCorpoCelula");
var styles = require("./TabelaCorpo.module.scss");
function TabelaCorpo(_a) {
    var dados = _a.dados, colunas = _a.colunas, onClickLinha = _a.onClickLinha, _b = _a.draggable, draggable = _b === void 0 ? false : _b;
    var _c = (0, react_1.useState)(dados), rows = _c[0], setRows = _c[1];
    var dragItem = (0, react_1.useRef)(null);
    var dragOverItem = (0, react_1.useRef)(null);
    var handleDragStart = function (index) {
        dragItem.current = index;
    };
    var handleDragEnter = function (index) {
        dragOverItem.current = index;
    };
    var handleDrop = function () {
        var copyRows = __spreadArray([], rows, true);
        var dragIdx = dragItem.current;
        var overIdx = dragOverItem.current;
        var draggedRow = copyRows[dragIdx];
        copyRows.splice(dragIdx, 1);
        copyRows.splice(overIdx, 0, draggedRow);
        setRows(copyRows);
        dragItem.current = null;
        dragOverItem.current = null;
    };
    return (react_1.default.createElement("tbody", null, rows.map(function (row, index) {
        var isDisabled = row.desabilitado;
        return (react_1.default.createElement("tr", { key: index, draggable: draggable && !isDisabled, className: "".concat(onClickLinha ? styles.rowClickable : "", " ").concat(isDisabled ? styles.rowDisabled : ""), onClick: function () { return !isDisabled && (onClickLinha === null || onClickLinha === void 0 ? void 0 : onClickLinha(row)); }, onDragStart: draggable && !isDisabled ? function () { return handleDragStart(index); } : undefined, onDragEnter: draggable && !isDisabled ? function () { return handleDragEnter(index); } : undefined, onDragEnd: draggable && !isDisabled ? handleDrop : undefined, style: {
                backgroundColor: isDisabled
                    ? "#f0f0f0"
                    : index % 2 === 0
                        ? "rgba(156, 156, 156, 0.1)"
                        : "#fff",
                cursor: onClickLinha
                    ? "pointer"
                    : draggable
                        ? "move"
                        : "default",
                opacity: isDisabled ? 0.6 : 1,
            } }, colunas.map(function (col) {
            var _a;
            return (react_1.default.createElement(TabelaCorpoCelula_1.TabelaCorpoCelula, { key: String(col.key), style: {
                    width: col.width,
                    textAlign: (_a = col.align) !== null && _a !== void 0 ? _a : "center",
                    height: 56,
                    paddingInline: 8,
                    fontSize: 14,
                    fontWeight: 500,
                    lineHeight: "20px",
                } }, col.Celula ? col.Celula(row) : String(row[col.key])));
        })));
    })));
}
